import { createRoot, type Root } from 'react-dom/client'
import { unstableSetRender } from 'antd'

/**
 * antd v5's static functions (message.open, notification, Modal.confirm, ...) can't reliably detect
 * React 19's `createRoot` through this app's webpack bundle of react-dom, so they silently no-op instead
 * of rendering — no error, no DOM node, nothing. This is antd's documented React 19 compat shim
 * (https://u.ant.design/v5-for-19): wire the render explicitly so static calls actually mount.
 */
unstableSetRender((node, container) => {
    const el = container as Element & { _reactRoot?: Root }
    el._reactRoot ||= createRoot(el)
    const root = el._reactRoot
    root.render(node)
    return async () => {
        await new Promise((resolve) => setTimeout(resolve, 0))
        root.unmount()
    }
})
